import React from 'react'

interface SiderContextType {
  collapsed: boolean
  setCollapsed: (collapsed: boolean) => void
}

export const SiderContext = React.createContext<SiderContextType>({
  collapsed: true,
  setCollapsed: () => {},
})

export const useSiderContext = () => React.useContext(SiderContext)
